<template>
  <router-link :to="to" class="item">
    <div class="photo">
      <div class="photo-holder">
        <img :src="item.imagemUrl"/>
      </div>
      <span v-if="item.leilao" class="leilao">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
        Leilão
      </span>
    </div>
    <div class="descricao">
      <span class="marca">{{item.marca}}</span>
      <span class="modelo">{{item.modelo}}</span>
    </div>
    <div class="atributos">
      <div class="attr">
        <span>{{item.anoFabricacao}}/{{item.anoModelo}}</span>
      </div>
      <div class="attr">
        <span>{{item.combustivel}}</span>
      </div>
    </div>
    <div class="atributos">
      <div class="attr">
        <span>{{item.km}}km</span>
      </div>
      <div class="attr">
        <span>{{item.placa}}</span>
      </div>
    </div>
    <div class="preco">
      <div>
        <span class="valor dashed">{{item.valorFipe}}</span><small> (fipe)</small>
      </div>
      <div>
        <span :class="['valor', { dashed: !!item.fechaAgora }]">{{item.valorInicial}}</span>
      </div>
      <div class="fecha-agora" v-if="item.fechaAgora">
        <span class="valor ">{{item.fechaAgora}}</span><small> (fecha agora)</small>
      </div>
    </div>
    <hr/>
    <div class="info">
      <span><font-awesome-icon :icon="['fas', 'map-marker-alt']"  /> {{item.cidade}}/{{item.uf}}</span>
      <span><font-awesome-icon :icon="['far', 'calendar-alt']"  /> {{item.tempo}}</span>
    </div>
  </router-link>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkerAlt, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons'

library.add(faMapMarkerAlt, faCalendarAlt, faExclamationCircle);

// Card de veículo da listagem (Home do lojista e vitrine pública). Recebe o item já no formato de exibição
// (ver cardFromListagem em services/vehicleModel.js): o card não formata valores nem decide rótulos.
export default {
  name: 'VehicleCard',
  props: {
    item: { type: Object, required: true },
    to: { type: [String, Object], required: true },
  },
}
</script>

<style scoped>
  /* Extraído de views/Home.vue (antes ".lista .veiculos .item ..."): mesmo visual, sem depender do contêiner. */
  .item{
    height: 445px;
    background: var(--white);
    overflow: hidden;
    border-radius: 4px;
    position: relative;
    display: flex;
    width: inherit;
    flex-direction: column;
    box-shadow: rgb(158 184 209 / 41%) 0px 2px 9px 0px;
    width: 100%;
    margin: 0 auto;
  }
  .item .photo{
    height: 186px;
      position: relative;
  }
  .item .photo .photo-holder{
    display: flex;
    width: 100%;
    height: 100%;
  }
    .item .photo .photo-holder img {
      width: 100%;
      height: 100%;
      object-fit: cover;
  }
  .item .atributos{
    display:flex;
    justify-content: space-between;
    padding-top: 12px;
    padding-left:12px;
    padding-right:12px;
  }
  .item .atributos .attr{
    font-weight: 500;
    font-size: 12px;
    color: var(--dark);

  }
  .item .descricao{
    padding-top: 8px;
    padding-left:12px;
    padding-right:12px;
    height: 72px;
    overflow: auto;
  }
  .item .descricao span{
    display: block;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
  }
  .item .preco{
    padding-top: 12px;
    padding-left:12px;
    padding-right:12px;
    color: var(--dark);
    flex: 1;
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
    font-size: 16px;
  }
  .item .preco > div{
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .item .preco .valor{
    font-weight: 900;
  }
  .item .preco .dashed{
    color:rgb(139, 140, 153);
  }
  .dashed{
    text-decoration: line-through;
  }
  .item hr{
    background-color: rgb(202 204 210);
    height: 1px;
    border: 0px;
    margin: 0;
    margin-top:8px
  }
  .item .info{
    padding-left:12px;
    padding-right:12px;
    font-weight: 500;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    flex-grow: 1;
    color: var(--dark);
    max-height: 32px;
        height: 32px;
  }
  .item .info .span{
    text-overflow: ellipsis;
  }

  .item:hover{
    color: var(--primary-color)
  }
  .item {
    color: var(--dark);
  }

  .fecha-agora{
    color: var(--danger)
  }

  .leilao{
    position: absolute;
    bottom: 0;
    right: 0;
    background: var(--danger);
    color: var(--white);
    font-size: 12px;
    padding: 4px 6px;
    font-weight: 600;
  }

@media (max-width: 992px){
  .item{
    max-width: 260px;
  }
}

@media (max-width: 768px){
  .item{
    max-width: 260px;
  }
  .item{
    max-width: 100%;
    height: 520px
  }
  .item .photo {
      height: 260px;
  }
  .item .atributos .attr {
    font-size:14px;
  }
  .item .preco {
    font-size: 18px;
  }
}
</style>
